

const upcomingEvents = [
  {
    id: "webinar-001",
    mainHeadline: "Infor MES Smart Factory Solutions ",
    subHeadline:
      "Transforming Manufacturing Operations with Digital Technology",
    eventDate: "May 20, 2025",
    time: "10:30 AM - 11:30 AM EST",
    location: "Virtual Event",
    briefDescription:
      "Join us for an informative webinar on Infor MES (Manufacturing Execution System) solutions, designed to help manufacturers overcome common shopfloor challenges and transform their operations. Learn how Infor MES serves as the backbone of a smart factory and bridges the gap between IT and OT (Operations Technology).",
    smallDescription:
      "Discover how Infor MES creates a paperless shopfloor with real-time visibility and control.",
    keyTakeaways: [
      "Fast MES Deployment Simplify deployment for regulated manufacturing with centralized components.",
      "Explore Infor's composable MES modules: Production, Quality, Inventory, Logistics, Maintenance, Tooling, Workflow, and Energy",
      "Learn about Infor MES's configurable approach that minimizes customizations and reduces total cost of ownership",
      "See how Infor MES creates a paperless shop floor with intuitive operator dashboards",
    ],
    speakerIntroductions: [
      {
        name: "Michael Roberts",
        title: "Solutions Architect, Infor MES",
        bio: "Michael specializes in helping manufacturers implement digital solutions that drive operational excellence and shopfloor productivity.",
      },
      {
        name: "Jennifer Chen",
        title: "Manufacturing Digital Transformation Lead, Infor",
        bio: "Jennifer has guided numerous manufacturers through their digital transformation journey using Infor MES solutions.",
      },
    ],
    registrationLink: "https://infor.com/register/mes-webinar",
    ticketPrice: "Complimentary",
    category: "Manufacturing Technology",
    imageUrl: "/images/events/infor-mes-webinar.jpg",
    agenda: [
      {
        time: "10:30 AM - 10:40 AM",
        activity: "Introduction and Manufacturing Challenges Overview",
      },
      {
        time: "10:40 AM - 10:50 AM",
        activity: "Infor MES Solution Architecture",
      },
      {
        time: "10:50 AM - 11:00 AM",
        activity: "Composable MES Modules Deep Dive",
      },
      {
        time: "11:00 AM - 11:20 AM",
        activity: "Implementation Approach and User Experience",
      },
      {
        time: "11:20 AM - 11:30 AM",
        activity: "Q&A Session",
      },
    ],
    targetAudience: [
      "Manufacturing Operations Leaders",
      "Plant Managers",
      "IT Directors in Manufacturing",
      "Production Supervisors",
      "Quality Managers",
      "Continuous Improvement Teams",
    ],
  },
];

const pastEvents = [
  // {
  //   id: "past-001",
  //   mainHeadline: "Sustainable Business Forum 2024",
  //   subHeadline: "Building a Greener Future",
  //   eventDate: "November 10, 2024",
  //   time: "10:00 AM - 3:30 PM PST",
  //   location: "Green Business Center, Portland, OR",
  //   briefDescription: "This forum brought together sustainability experts and business leaders to discuss strategies for environmental responsibility and sustainable growth.",
  //   smallDescription: "A gathering focused on green business practices and sustainability.",
  //   keyTakeaways: [
  //     "Sustainable business models for long-term growth",
  //     "Reducing carbon footprint while increasing profits",
  //     "Consumer trends in eco-friendly products"
  //   ],
  //   speakerIntroductions: [
  //     {
  //       name: "Emily Johnson",
  //       title: "Sustainability Director, EcoFuture Enterprises",
  //       bio: "Emily has helped dozens of companies transition to sustainable practices while improving their bottom line."
  //     }
  //   ],
  //   highlights: [
  //     "Panel discussion on renewable energy adoption in manufacturing",
  //     "Networking session with over 200 sustainability professionals",
  //     "Launch of the Green Business Initiative"
  //   ],
  //   attendeeCount: 350,
  //   testimonials: [
  //     {
  //       name: "Robert Smith",
  //       company: "Global Manufacturing Inc.",
  //       quote: "This forum provided actionable insights that we've already begun implementing in our operations."
  //     }
  //   ],
  //   recordingLink: "https://example.com/recordings/sustainable-forum",
  //   presentationMaterials: "https://example.com/materials/sustainable-forum",
  //   imageGallery: ["/images/events/past/sus-forum-1.jpg", "/images/events/past/sus-forum-2.jpg"]
  // },
  // {
  //   id: "past-002",
  //   mainHeadline: "Digital Marketing Masterclass",
  //   subHeadline: "Strategies for the Modern Marketer",
  //   eventDate: "September 5, 2024",
  //   time: "1:00 PM - 6:00 PM EST",
  //   location: "Marketing Hub, New York, NY",
  //   briefDescription: "An intensive half-day workshop covering the latest digital marketing strategies, tools, and best practices for today's competitive landscape.",
  //   smallDescription: "Expert-led workshop on cutting-edge digital marketing techniques.",
  //   keyTakeaways: [
  //     "Advanced social media marketing tactics",
  //     "Data-driven marketing decision making",
  //     "Emerging trends in content marketing"
  //   ],
  //   speakerIntroductions: [
  //     {
  //       name: "Alicia Torres",
  //       title: "Chief Marketing Officer, DigitalEdge",
  //       bio: "Alicia has led marketing campaigns for Fortune 500 companies and startups alike, specializing in digital transformation."
  //     }
  //   ],
  //   highlights: [
  //     "Interactive workshop on SEO optimization",
  //     "Case study presentations of successful campaigns",
  //     "Personalized marketing strategy consultations"
  //   ],
  //   attendeeCount: 120,
  //   feedbackRating: 4.8,
  //   resourcePackage: "https://example.com/resources/marketing-masterclass"
  // },
 
];

const featuredEvents = [

  
];


export { upcomingEvents, pastEvents, featuredEvents };